import React from 'react';
import { Button } from '@mui/material';

const AutoReloadButton = ({ onClick, sx, disabled = false }) => (
  <Button disabled={disabled} color="primary" onClick={onClick} sx={sx}>
    Set reload
  </Button>
);

export default AutoReloadButton;
